import React, { useState } from 'react';
import { useDialog } from '../DialogContext'; 

const STAT_ICONS = { 
  vision: "🕯️ Vision", 
  intelligence: "📜 Intelligence", 
  discipline: "⚔️ Discipline", 
  energy: "🔥 Energy", 
  wealth: "⚜️ Wealth" 
};

const VINTAGE_BEIGE = "#e5d1a5"; 
const JERUSALEM_GOLD = "#c5a059"; 

const Planner = ({ player, setPlayer, updateBacklog }) => {
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState("");

  const [draftText, setDraftText] = useState("");
  const [draftStat, setDraftStat] = useState("vision");
  const [draftVal, setDraftVal] = useState(10); 

  const [isPressed, setIsPressed] = useState(false);

  // DİYALOG FONKSİYONUNU ÇEKİYORUZ
  const { showConfirm } = useDialog();

  const startEditing = (item) => {
    setEditingId(item.id);
    setEditText(item.text);
  };

  const submitEdit = (id) => {
    updateBacklog(id, editText);
    setEditingId(null);
  };

  const handleAddQuest = () => {
    if (!draftText.trim()) return;
    const newItem = {
      id: Date.now(),
      text: draftText,
      stat: draftStat,
      val: Number(draftVal)
    };
    setPlayer(prev => ({ ...prev, backlog: [...(prev.backlog || []), newItem] }));
    setDraftText(""); 
  };

  // KRİTİK GÜNCELLEME: ACTIVATE BUTONU ARTIK ONAY (CONFIRM) İSTİYOR!
  const handleActivateQuest = (item) => {
    showConfirm(`Are you ready to activate "${item.text}"? This will move the objective to your dashboard.`, () => {
      setPlayer(prev => {
        const newBacklog = (prev.backlog || []).filter(b => b.id !== item.id);
        
        let assignedPriority = 'low';
        if (item.val === 20 || item.val === 30) assignedPriority = 'medium';
        if (item.val === 50) assignedPriority = 'high';

        const newActiveQuests = [...(prev.activeQuests || []), { 
          id: Date.now(), 
          text: item.text, 
          stat: item.stat || 'discipline', 
          priority: assignedPriority, 
          val: item.val || 10 
        }];

        return { ...prev, backlog: newBacklog, activeQuests: newActiveQuests };
      });
    }, "Activate Quest");
  };

  const handleDeleteQuest = (id) => {
    showConfirm("Delete this planned quest?", () => {
      setPlayer(prev => ({ ...prev, backlog: (prev.backlog || []).filter(b => b.id !== id) }));
    }, "Delete Quest");
  };

  return (
    <div style={{
      minHeight: '80vh', padding: '40px', display: 'flex', flexDirection: 'column',
      backgroundColor: 'var(--sidebar-bg)', 
      border: `1px solid ${JERUSALEM_GOLD}`,
      boxShadow: 'inset 0 0 50px rgba(0,0,0,0.5), 0 10px 30px rgba(0,0,0,0.3)',
      borderRadius: '2px'
    }}>
      
      <div style={{borderBottom: `1px solid ${JERUSALEM_GOLD}`, paddingBottom: '15px', marginBottom: '35px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end'}}>
        <div>
<h3 style={{
  fontFamily: 'Cinzel, serif', 
  color: JERUSALEM_GOLD, 
  margin: 0, 
  fontSize: '1.6rem', // Burası da 1.6rem
  letterSpacing: '2px', 
  textTransform: 'uppercase', 
  textShadow: '1px 1px 3px rgba(0,0,0,0.8)'
}}>
  Quest Planner
</h3>
          <p style={{fontFamily: 'Courier Prime, monospace', color: VINTAGE_BEIGE, opacity: 0.8, fontSize: '0.95rem', margin: '5px 0 0 0', letterSpacing: '1px'}}>
            Design your upcoming missions and assign their attributes.
          </p>
        </div>
        <span style={{fontFamily: 'Cinzel, serif', color: 'var(--accent-red)', fontSize: '1.2rem', fontWeight: 'bold', textShadow: '1px 1px 2px rgba(0,0,0,0.5)'}}>
          {player.backlog?.length || 0} Quests Pending
        </span>
      </div>

      <div style={{
        display: 'flex', alignItems: 'stretch', gap: '0',
        marginBottom: '40px', border: `1px solid ${JERUSALEM_GOLD}`, 
        borderRadius: '2px', backgroundColor: 'rgba(0, 0, 0, 0.4)'
      }}>
        <input 
          style={{
            flex: '3', minWidth: '250px', padding: '15px 20px', fontSize: '1.05rem', 
            backgroundColor: 'transparent', border: 'none', borderRight: `1px dashed ${JERUSALEM_GOLD}`, outline: 'none',
            color: '#fdfbf7', fontFamily: 'Courier Prime, monospace'
          }}
          className="vintage-input" 
          value={draftText} 
          onChange={e => setDraftText(e.target.value)} 
          onKeyDown={(e) => e.key === 'Enter' && handleAddQuest()}
          placeholder="What is your next objective?..." 
        />
        
        <select 
          value={draftStat}
          onChange={e => setDraftStat(e.target.value)}
          style={{
            flex: '1', minWidth: '150px', padding: '0 15px', fontSize: '0.9rem', cursor: 'pointer',
            backgroundColor: 'transparent', border: 'none', borderRight: `1px dashed ${JERUSALEM_GOLD}`, 
            color: JERUSALEM_GOLD, fontFamily: 'Courier Prime, monospace', outline: 'none', fontWeight: 'bold'
          }}
        >
          {Object.entries(STAT_ICONS).map(([key, label]) => (
            <option key={key} value={key} style={{background: 'var(--sidebar-bg)', color: JERUSALEM_GOLD}}>{label}</option>
          ))}
        </select>

        <select 
          value={draftVal}
          onChange={e => setDraftVal(Number(e.target.value))}
          style={{
            flex: '1', minWidth: '150px', padding: '0 15px', fontSize: '0.9rem', cursor: 'pointer',
            backgroundColor: 'transparent', border: 'none', borderRight: `1px solid ${JERUSALEM_GOLD}`, 
            color: JERUSALEM_GOLD, fontFamily: 'Courier Prime, monospace', outline: 'none', fontWeight: 'bold'
          }}
        >
          <option value={10} style={{background: 'var(--sidebar-bg)', color: JERUSALEM_GOLD}}>Easy (10 XP)</option>
          <option value={20} style={{background: 'var(--sidebar-bg)', color: JERUSALEM_GOLD}}>Medium (20 XP)</option>
          <option value={30} style={{background: 'var(--sidebar-bg)', color: JERUSALEM_GOLD}}>Hard (30 XP)</option>
          <option value={50} style={{background: 'var(--sidebar-bg)', color: JERUSALEM_GOLD}}>Epic (50 XP)</option>
        </select>

        <button 
          className="wax-seal-btn"
          style={{
            flex: '1', minWidth: '130px', fontSize: '0.95rem', fontFamily: 'Cinzel, serif', fontWeight: 'bold',
            letterSpacing: '2px', backgroundColor: isPressed ? '#5a0d0e' : 'var(--accent-red)', color: '#fff', 
            border: 'none', borderRadius: '0', cursor: 'pointer', transition: 'all 0.1s ease-in-out',
            display: 'flex', alignItems: 'center', justifyContent: 'center', textTransform: 'uppercase', height: 'auto',
            transform: isPressed ? 'scale(0.97)' : 'scale(1)', 
            boxShadow: isPressed ? 'inset 0 3px 10px rgba(0,0,0,0.6)' : '0 3px 6px rgba(0,0,0,0.3)',
          }} 
          onClick={handleAddQuest}
          onMouseDown={() => setIsPressed(true)}
          onMouseUp={() => setIsPressed(false)}
          onMouseLeave={() => setIsPressed(false)} 
        >
          DRAFT QUEST
        </button>
      </div>

      {(!player.backlog || player.backlog.length === 0) ? (
        <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 0.8, fontStyle: 'italic', fontFamily: 'Courier Prime, monospace', fontSize: '1.1rem', color: VINTAGE_BEIGE, border: `1px dashed ${JERUSALEM_GOLD}`, backgroundColor: 'rgba(0,0,0,0.2)'}}>
          No planned quests. Add a new objective to begin.
        </div>
      ) : (
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '25px', alignContent: 'start'}}>
          {player.backlog.slice().reverse().map(item => (
            <div key={item.id} style={{
              backgroundColor: 'rgba(0,0,0,0.3)', border: `1px solid ${JERUSALEM_GOLD}`, 
              borderTop: '4px solid var(--accent-red)', borderRadius: '2px', 
              padding: '25px 25px 20px', display: 'flex', flexDirection: 'column',
              boxShadow: '0 6px 15px rgba(0,0,0,0.5)', transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)', position: 'relative'
            }}
            onMouseOver={(e) => { 
              e.currentTarget.style.transform = 'translateY(-5px)'; 
              e.currentTarget.style.boxShadow = `0 0 20px rgba(197, 160, 89, 0.4)`;
              e.currentTarget.style.borderColor = 'var(--accent-red)';
            }}
            onMouseOut={(e) => { 
              e.currentTarget.style.transform = 'translateY(0)'; 
              e.currentTarget.style.boxShadow = '0 6px 15px rgba(0,0,0,0.5)';
              e.currentTarget.style.borderColor = JERUSALEM_GOLD;
            }}
            >
              
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '18px', borderBottom: `1px dashed ${VINTAGE_BEIGE}`, paddingBottom: '12px'}}>
                 <span style={{fontSize: '0.8rem', fontFamily: 'Cinzel, serif', color: VINTAGE_BEIGE, textTransform: 'uppercase', letterSpacing: '1.5px', fontWeight: 'bold'}}>
                   {STAT_ICONS[item.stat] || "⚔️ Objective"}
                 </span>
                 <span style={{
                   fontSize: '0.85rem', fontFamily: 'Courier Prime, monospace', 
                   color: JERUSALEM_GOLD, fontWeight: 'bold', 
                   border: `1px solid ${JERUSALEM_GOLD}`, padding: '3px 10px', borderRadius: '2px', 
                   backgroundColor: 'rgba(197, 160, 89, 0.1)',
                   textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
                 }}>
                   {item.val || 10} XP
                 </span>
              </div>

              {editingId === item.id ? (
                <textarea 
                  className="vintage-input"
                  spellCheck="false"
                  style={{
                    width: '100%', resize: 'none', flex: 1, marginBottom: '20px', fontSize: '1.05rem', 
                    backgroundColor: 'rgba(255,255,255,0.05)', color: '#fdfbf7', padding: '15px', borderRadius: '2px',
                    minHeight: '100px', fontFamily: 'Courier Prime, monospace', border: `1px dashed ${JERUSALEM_GOLD}`,
                    outline: 'none', lineHeight: '32px',
                    backgroundImage: `repeating-linear-gradient(transparent, transparent 31px, rgba(197, 160, 89, 0.1) 31px, rgba(197, 160, 89, 0.1) 32px)`,
                    backgroundAttachment: 'local'
                  }}
                  value={editText}
                  onChange={(e) => setEditText(e.target.value)}
                  onBlur={() => submitEdit(item.id)}
                  onKeyDown={(e) => e.key === 'Enter' && !e.shiftKey && submitEdit(item.id)}
                  autoFocus
                />
              ) : (
                <p 
                  onClick={() => startEditing(item)} 
                  style={{
                    flex: 1, cursor: 'text', fontSize: '1.05rem', minHeight: '100px', color: '#fdfbf7', lineHeight: '32px', fontFamily: 'Courier Prime, monospace', margin: '0 0 20px 0',
                    backgroundImage: `repeating-linear-gradient(transparent, transparent 31px, rgba(197, 160, 89, 0.1) 31px, rgba(197, 160, 89, 0.1) 32px)`,
                    padding: '0 5px', backgroundAttachment: 'local'
                  }} 
                  title="Click to edit"
                >
                  {item.text}
                </p>
              )}

              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 'auto', borderTop: `1px dashed rgba(229, 209, 165, 0.2)`, paddingTop: '15px'}}>
                <button 
                  style={{
                    backgroundColor: 'var(--accent-red)', border: '1px solid #5a0d0e', color: JERUSALEM_GOLD, 
                    padding: '10px 22px', cursor: 'pointer', fontFamily: 'Cinzel, serif', fontWeight: 'bold', 
                    fontSize: '0.9rem', letterSpacing: '1.5px', transition: 'all 0.2s', borderRadius: '2px',
                    textTransform: 'uppercase', boxShadow: '0 3px 6px rgba(0,0,0,0.4)',
                    display: 'flex', alignItems: 'center'
                  }}
                  onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#5a0d0e'; e.currentTarget.style.borderColor = JERUSALEM_GOLD; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                  onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'var(--accent-red)'; e.currentTarget.style.borderColor = '#5a0d0e'; e.currentTarget.style.transform = 'translateY(0)'; }}
                  onClick={() => handleActivateQuest(item)}
                >
                  ACTIVATE
                </button>
                <button 
                  style={{background: 'none', border: 'none', color: VINTAGE_BEIGE, opacity: 0.6, cursor: 'pointer', fontSize: '0.85rem', fontFamily: 'Cinzel, serif', fontWeight: 'bold', letterSpacing: '1.5px', transition: 'all 0.2s', textTransform: 'uppercase'}}
                  onMouseOver={(e) => { e.currentTarget.style.color = 'var(--accent-red)'; e.currentTarget.style.opacity = 1; }}
                  onMouseOut={(e) => { e.currentTarget.style.color = VINTAGE_BEIGE; e.currentTarget.style.opacity = 0.6; }}
                  onClick={() => handleDeleteQuest(item.id)}
                >
                  DELETE
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Planner;